module.exports = __webpack_public_path__ + "img/activeupskillscourse.5f7cd128.svg";